// Image/asset references for /travel-credit-card. Empty string = not yet
// exported from Figma; components render a neutral placeholder when a src is
// empty. Replace with optimized WebP/AVIF (images) and SVG (logos), ideally
// served from the ixigo image CDN.
export const ASSETS = {
	// ixigo wordmark (white). Feeds the sticky StageHeader (web main flow), the
	// mweb hero, and the apply page; where empty the components fall back to the
	// orange text-chip logo.
	ixigoLogo:
		'https://images.ixigo.com/image/upload/payments/cffb53c8f2ee917ffff766330ae3bf7f-qjzpl.png',
	// Hero (home fold) ambient background — the WEB home hero + the Manage Card
	// desktop hero. (mweb's home hero uses heroBackgroundMobile below — its own
	// mobile-composed asset, since this desktop image's safe area is wrong on
	// phones.) NOTE: this used to match the carousel's first backdrop
	// (galleryBackgrounds[0]) for a pixel-identical hero->carousel hand-off; they
	// now differ, so that transition is a visible (not seamless) change. Set
	// galleryBackgrounds[0] to this same URL to restore the match.
	heroBackground:
		'https://images.ixigo.com/image/upload/payments/902d212dd8b5d2ba0efb679dcd3a35ed-motks.webp',
	// MWEB home-hero background — a mobile-composed backdrop (portrait safe area),
	// used by sections/hero/hero.tsx [data-hero-bg]. Kept separate from the
	// desktop heroBackground AND from manageCardHeroMobile (different context)
	// even though the URL may currently coincide with the latter.
	heroBackgroundMobile:
		'https://images.ixigo.com/image/upload/payments/b7abfcc918532123f884f00055cf4756-ysesw.webp',
	cardFront:
		'https://images.ixigo.com/image/upload/payments/29068652dab10882ee90e7210d575958-jwrda.png',
	// Card BACK face (magnetic stripe, embossed number, VISA) — the front
	// 3D-flips about its vertical axis to reveal this in the forex/fuel benefit
	// steps (replaces the old RuPay->VISA horizontal swipe). Same aspect ratio as
	// cardFront so the two faces stack pixel-aligned during the flip.
	cardBack:
		'https://images.ixigo.com/image/upload/payments/e6309f2b05383e9db9eb42d70b3e0640-kcxes.png',
	// Single combined strip (VISA + RuPay + AU Small Finance Bank), not 3 files.
	networkLogos:
		'https://images.ixigo.com/image/upload/payments/e49fdd96a78410efb16e94e6becd5cbe-uoyty.png',
	// Wide horizontal strip of partner brand logos (2840x80) — feeds the
	// "Works with every brand" infinite marquee on the Unlock section.
	brandStrip:
		'https://images.ixigo.com/image/upload/payments/e19c54ac3203e8ea95c0273b7013011f-ahjtn.png',
	// The LAST showcase slide = the full-screen "flight" still (the enlarged frame
	// that expands to fill the screen at the carousel→video handoff). Decoupled
	// from clip 0's video poster (TRANSITION_POSTER) on purpose: this is purely the
	// still shown for the last carousel slide + the expanded full-screen flight.
	// NOTE: it no longer pixel-matches clip 0's first video frame, so the expanded
	// still → video hard-cut may show a slight jump (accepted — see showcase.tsx).
	flightStill:
		'https://images.ixigo.com/image/upload/payments/c63171d0e56a2fa53cd66b5b57f71c85-ezbuo.webp',
	// Crisp still for the bus-interior boundary frame — shared by clip 1's END
	// (hotel→bus interior) and clip 2's FRAME 0 (train clip opens on the bus). The
	// conductor fades it in only while the journey RESTS on that frame, so it must
	// pixel-match the video boundary (it does: same source as the clip frames) or
	// the reveal would jump. Hosted (was bundled locally). See destination-scene.tsx.
	busEndStill:
		'https://images.ixigo.com/image/upload/payments/609bf1d31dd60301081db869a974b081-lkxyj.jpg',
	// Crisp end-still for the LAST clip (train interior) — the journey's terminal
	// rest. Same role as busEndStill: must pixel-match the train clip's final frame
	// (verified ~28 PSNR, same as the prior bundled still) or the reveal would jump.
	// Hosted (was bundled locally as train-end-still.webp). See destination-scene.tsx.
	trainEndStill:
		'https://images.ixigo.com/image/upload/payments/fef7da189be290410d616f1628a3ff3a-jgqrw.webp',
	// Transition-clip POSTERS (frame 0 of each clip — the buffering fallback shown
	// only if the clip isn't ready when scroll reaches it). Each MUST pixel-match
	// its video's first frame (verified ~44 PSNR) or the poster→video play start
	// jumps. Hosted (were bundled locally). See transition-clips.ts.
	//   clip 1 (hotel→bus interior) frame 0 — the hotel room.
	hotelBusPoster:
		'https://images.ixigo.com/image/upload/payments/50d13ae9a922764e4c5800709cf9f7e4-enpjk.jpg',
	//   clip 2 (train) frame 0 — opens on the bus interior, then pans to the train.
	trainPoster:
		'https://images.ixigo.com/image/upload/payments/14dfd40502984705cd93893d55992ebf-uzpts.jpg',
	// Showcase carousel images (480x720, 2:3) shown in the enlarged frame after
	// the card sequence.
	gallery: [
		// POS machine ("2.5% Reward Points") shows first
		'https://images.ixigo.com/image/upload/payments/f0ec654db37ac495cc57431f0eb81c08-ynpmc.webp',
		'https://images.ixigo.com/image/upload/payments/6453a834286bae64c117953fcfbefbd3-crbsd.webp',
		'https://images.ixigo.com/image/upload/payments/d20bf6f6c10e896e0b6381007d3e9961-wqgdn.webp',
		'https://images.ixigo.com/image/upload/payments/dec57bc04f7a2cf353ad4db3fe153c1a-dwbfm.webp',
	],
	// Full-screen backdrops behind the showcase carousel — one per gallery
	// slide, same order (travel table, concierge desk, lounge, plane cabin).
	// Sources are SHARP; the blur is applied in CSS so it stays intact while
	// the backdrops slide during carousel advances.
	galleryBackgrounds: [
		'https://images.ixigo.com/image/upload/payments/f92d53f28db86c89a8eef6bc60c25192-titsr.webp',
		'https://images.ixigo.com/image/upload/payments/c90e445c0f0e15fae0a10a14a6d5058f-rwejy.webp',
		'https://images.ixigo.com/image/upload/payments/6ad6e1e8902beaef10c3361c5ed7a82b-yeyhe.webp',
		'https://images.ixigo.com/image/upload/payments/96e92d97e1bc1bd198f1944c53977461-gfxjf.webp',
	],
	// Destination ("Flights") image — zoomed into from the plane-window center.
	destination:
		'https://images.ixigo.com/image/upload/payments/37e6ec4d844fe72bf57d4c527aaaddfa-fluev.webp',
	// Hotel-room scene (the valley framed in the room window) — second nav stop.
	hotel:
		'https://images.ixigo.com/image/upload/payments/94860523d98fc4bd3ca756801729027c-bkldp.webp',
	// Transparent plane window (oval glass cut out, same 1440x1024 as the valley)
	// overlaid on the valley for the fly-through; the oval reveals the valley
	// behind it while the cabin flies past the screen edges.
	planeWindow:
		'https://images.ixigo.com/image/upload/payments/0c166b792a1380cd959b4fdbf29b023b-peiiw.webp',
	// /travel-credit-card/apply background. Empty string falls back to the
	// gradient placeholder in apply-page.tsx until the Figma export lands.
	applyBackground: '',
	// Mobile-only backdrop for the APPROVED-user Manage Card hero — paired
	// with `heroBackground` via <picture> so each viewport gets a properly
	// composed asset (the desktop image's safe area is wrong on phones).
	manageCardHeroMobile:
		'https://images.ixigo.com/image/upload/payments/b7abfcc918532123f884f00055cf4756-ysesw.webp',
	// Account-dashboard mockup for the Unlock section's wide feature card (text
	// left / image right on web, stacked on mweb).
	accountMockup:
		'https://images.ixigo.com/image/upload/payments/944f6537d13c7cb7a758e9cfc11595c9-tfeui.png',
	// Icons for the Unlock-section stat cards — ONE per card, in card order
	// (the wide feature card is first and has no icon, so these map to the
	// remaining stat cards 1:1). Placeholders for now — replace per final Figma.
	unlockCardIcons: [
		'https://images.ixigo.com/image/upload/payments/bcdb4780e78f7fa5a0eb1a37b3474565-wgqri.png',
		'https://images.ixigo.com/image/upload/payments/9bf5a08b04d851172d15bbf8b983bd67-vatxs.png',
		'https://images.ixigo.com/image/upload/payments/86b2f513f47421a567b1d2f9b7a630b5-tknbf.png',
		'https://images.ixigo.com/image/upload/payments/c7495108801772f2c379f63a272ecca7-qdorg.png',
	],
	// Logos for the "Core Features" deal cards — ONE per card, in MANAGE_CARD_DEALS
	// .cards order (Flights, Bus, Hotels, Trains). Shared by the web + mweb deals
	// adapters.
	dealCardLogos: [
		'https://images.ixigo.com/image/upload/payments/3fa557bf15d0abb220f1b054a9528205-rnhud.png',
		'https://images.ixigo.com/image/upload/payments/23f16d99a72ba4588470e1a142d7feb5-karlt.png',
		'https://images.ixigo.com/image/upload/payments/4ee2bbb35807336620b6e894928ef7cb-ezsjl.png',
		'https://images.ixigo.com/image/upload/payments/c2228359e691e90ead50ef95ffa9f501-nlpbd.png',
	],
	// Images for the "Real Rewards" benefits carousel — ONE per benefit, in
	// MANAGE_CARD_BENEFITS.items order (Lounge, Fuel, Reward, Insurance, Concierge,
	// Forex). Shared by the web (vertical carousel) + mweb (in-panel) adapters.
	// Empty string = not yet exported; the adapters fall back to a gallery image.
	benefitImages: [
		'https://images.ixigo.com/image/upload/payments/e452b6df6db9ab09083fb2126e2a2206-rdkvn.webp', // 16 Lounge Visits
		'https://images.ixigo.com/image/upload/payments/38cdb37db0be2e6af8eda52f0de5faa9-cwfwp.webp', // 1% Fuel Surcharge Waiver
		'https://images.ixigo.com/image/upload/payments/b822d2dc4c362380cac5f3143c925b08-oxxkh.webp', // 2.5% Reward Points
		'https://images.ixigo.com/image/upload/payments/3c5a0b3f1b3a935af26f7b89d0d804ed-aoobf.webp', // ₹2 Lakh Travel Insurance
		'https://images.ixigo.com/image/upload/payments/3026eb6ed1c40ca67d88247fc60d890d-bqxpm.webp', // 24×7 Concierge Support
		'https://images.ixigo.com/image/upload/payments/a20140b075a2b4f4cec7c8c9bbc317aa-ffwta.png', // Zero forex markup
	],
	// VISA "Business Excellence" award badge — gold laurel wreath + divider +
	// 3 stars, transparent centre (the VISA wordmark + caption are overlaid in
	// AwardBadge). Shown beside the section heading in the MAIN marketing flow.
	awardBadge:
		'https://images.ixigo.com/image/upload/payments/84d5f28d1afd96678f67a3c4d06d0acd-owxgv.png',
	// Red-document "application pending" icon — the left adornment of the mweb
	// pending nudge (CbccPendingNudge).
	pendingNudgeIcon:
		'https://images.ixigo.com/image/upload/payments/4c54e199b251ce668d0ea2d33c1b4f73-zmtst.webp',
} as const;
